import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonNote,
  IonSearchbar,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
// Selectors
import { checkmarkOutline, chevronBack } from "ionicons/icons";
import { Client } from "../../../@types/client";
import { selectClients } from "../../../store/clients/selectors/selectClients";
import findPendingInvoicesByClientIdentifier from "../../../store/paymentNoticeDetail/actions/findPendingInvoicesByClientIdentifier";
import { selectClientSelectorSearchText } from "../../../store/paymentNoticeDetail/selectors/selectClientSelectorSearchText";
import { selectPaymentNotice } from "../../../store/paymentNoticeDetail/selectors/selectPaymentNotice";

export const ClientSelector: React.FC = () => {
  const clients = useSelector(selectClients);
  const searchText = useSelector(selectClientSelectorSearchText);
  const dispatch = useDispatch();

  const selectClient = (clientSelected: Client) => {
    setShowModal(false);
    dispatch({
      type: "paymentNoticeDetail/updatePaymentNoticesCreateFormDataItem",
      payload: {
        client: clientSelected,
      },
    });

    dispatch(
      findPendingInvoicesByClientIdentifier(clientSelected?.identifier || "")
    );
  };

  const [showModal, setShowModal] = useState(false);
  const paymentNotice = useSelector(selectPaymentNotice);
  return (
    <div>
      <IonItem
        onClick={() => setShowModal(true)}
        detail={true}
        button
        lines="none"
      >
        <IonLabel class="ion-text-wrap">
          <p>Cliente</p>
          <h2>
            <strong>
              <IonText color="primary">
                {paymentNotice.client?.name || "No has seleccionado aún"}
              </IonText>
            </strong>
          </h2>
          <p>{paymentNotice.client?.identifierFormatted}</p>
        </IonLabel>
      </IonItem>
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => {
          setShowModal(false);
          dispatch({
            type: "paymentNoticeDetail/updateClientSelectorSearchText",
            payload: "",
          });
        }}
      >
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => setShowModal(false)}>
                <IonIcon icon={chevronBack}></IonIcon>
              </IonButton>
            </IonButtons>
            <IonTitle>Seleccionar Cliente</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonSearchbar
            placeholder="Buscar"
            value={searchText}
            onIonChange={(e: any) => {
              dispatch({
                type: "paymentNoticeDetail/updateClientSelectorSearchText",
                payload: e.detail.value,
              });
            }}
          />
          <IonList>
            <IonListHeader>
              <IonLabel>
                <IonText color="tertiary">
                  <strong>{`${clients.length} clientes encontrados`}</strong>
                </IonText>
              </IonLabel>
            </IonListHeader>
            {clients.slice(0, 30).map((client) => (
              <IonItem
                onClick={() => {
                  selectClient(client);
                }}
                key={client.identifier}
                lines="none"
                style={{
                  borderRadius: "4px",
                }}
                button
                detail={false}
              >
                <IonLabel>
                  <IonText color="primary">
                    <strong>{client.name}</strong>
                  </IonText>
                  <h6>{client.identifierFormatted}</h6>
                </IonLabel>
                {client.identifier === paymentNotice.client?.identifier && (
                  <IonNote slot="end">
                    <IonIcon
                      icon={checkmarkOutline}
                      color="primary"
                      size="large"
                    ></IonIcon>
                  </IonNote>
                )}
              </IonItem>
            ))}
          </IonList>
        </IonContent>
      </IonModal>
    </div>
  );
};
